import {
  Box,
  Button,
  Typography,
  CircularProgress,
  Skeleton,
  Card,
} from "@mui/material";
import { createCheckout } from "@/services/api";
import { useArtist, useCapacity } from "@/services/hooks";
import { SubscribedContext } from "@/providers/Subscribed";
import { useContext, useState } from "react";
export default function SubscribeButton({ artistKey }) {
  const { data: artist, isLoading } = useArtist(artistKey);
  const { isSubscribed, country, isLimited } = useContext(SubscribedContext);
  const { data: capacity } = useCapacity(artistKey);
  const [loading, setLoading] = useState(false);

  const handleSubscribe = async () => {
    try {
      setLoading(true);
      const response = await createCheckout(artistKey);
      window.location.href = response.url;
    } catch (error) {
      console.error("Error creating checkout:", error);
      alert("Error creating checkout. Please contact support@notebook.fm");
    } finally {
      setLoading(false);
    }
  };

  const checkTerritory = () => {
    // console.log("territories", artist?.meta?.territories);
    // console.log("country", country);
    if (
      artist?.meta?.territories == null ||
      artist?.meta?.territories?.length === 0
    ) {
      return true;
    }

    return artist?.meta?.territories?.includes(country);
  };

  const isVerified = artist?.verified;
  // console.log("isVerified", isVerified);
  const hasCapacity = capacity?.count > 0 || capacity?.count == null;
  // console.log("hasCapacity", hasCapacity);
  const isTerritory = checkTerritory();
  // console.log("isTerritory", isTerritory);

  const canSubscribe = isVerified && isTerritory && hasCapacity;
  const isDisabled = !canSubscribe;

  if (isSubscribed || isLoading || !artist) {
    return null;
  }

  const getCode = () => {
    if (artistKey === "oneruel") {
      // from local storage
      const code = localStorage.getItem("code");
      return code;
    }
    return null;
  };

  return (
    <Box
      sx={{
        mt: 4,
        mx: 2,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {isLimited && isTerritory && (
        <Card sx={{ mb: 2, p: 2, borderRadius: "25px" }}>
          <Typography variant="h6">
            We're working on getting licenses in more countries.
          </Typography>
          <Typography variant="caption">
            It looks like you're accessing Notebook from a country ({country})
            in which we don't currently have a license to stream music.
            Licensing music protects artists and songwriters, which is core to
            our mission. We're working hard to get licenses in more countries.
            In the meantime, you can subscribe to my Pocketbook for half price.
            You'll get access notes, forums, media, merch, meetups, and more —
            but you won't be able to stream any music.
          </Typography>
        </Card>
      )}

      {getCode() && (
        <Box sx={{ mb: 0 }}>
          <Typography variant="caption" color="secondary">
            You've unlocked a one month free trial
          </Typography>
        </Box>
      )}

      {(artistKey === "jordymusic" ||
        artistKey === "brittneyspencer" ||
        artistKey === "brendanabernathy") && (
        <Box sx={{ mb: 0 }}>
          <Typography variant="caption" color="secondary">
            You've unlocked a 7 day free trial.
          </Typography>
        </Box>
      )}

      <Button
        variant="contained"
        fullWidth
        color="primary"
        onClick={handleSubscribe}
        sx={{
          borderRadius: 10,
          mb: 1,
        }}
        disabled={isDisabled || loading}
      >
        {loading ? (
          <CircularProgress size={20} sx={{ my: 0.5 }} />
        ) : (
          "Subscribe"
        )}
      </Button>
      {isDisabled && (
        <Typography variant="body2" color="text.secondary" align="center">
          {`${artist?.name} is currently at capacity. Stay tuned!`}
        </Typography>
      )}
    </Box>
  );
}
